import styled from 'styled-components';
import { LanguageSwitcherStyled } from '../LanguageSwitcherStyled';

export const LanguageSwitcherStyledAC = styled(LanguageSwitcherStyled)`
    background-color: ${({ theme }) => theme.colors.grey6};
`;
